export const API_BASE: string =
  import.meta.env.VITE_API_BASE ?? 'http://localhost:3001';
export const TENANT_ID: string = import.meta.env.VITE_TENANT_ID ?? '';
export const CLIENT_ID: string = import.meta.env.VITE_CLIENT_ID ?? '';
